<script setup lang="ts">
const { t } = useEkI18n();
const settingsStore = useSettingsStore();
const accountSettingsStore = useAccountSettingsStore();

const activeTabs = computed(() => {
  const activeTabs = [
    MaterialStartTabSetting.all,
    MaterialStartTabSetting.wholesalerCatalog, 
    MaterialStartTabSetting.locations, 
    MaterialStartTabSetting.favorites, 
    MaterialStartTabSetting.ownItems
  ];

  if (accountSettingsStore.accountSettings.UseInventory === false) {
    activeTabs.splice(activeTabs.indexOf(MaterialStartTabSetting.locations), 1);
  }

  return activeTabs;
});

async function updateStartTab(selected: MaterialStartTabSetting) {
  await settingsStore.set('materialsStartTab', selected);
}

</script>

<template>
  <SettingsSelect
    :options="activeTabs"
    :label="t('settings.materials.standardTab')"
    :description="t('settings.materials.standardTabDescription')"
    :value="settingsStore.settings.materialsStartTab"
    :placeholder="settingsStore.settings.worksheetsStartTab"
    :resolve-key="(o: MaterialStartTabSetting)=>o"
    @change="updateStartTab"
  >
    <template #option="{option}">
      {{ t("materials.segments." + option) }}
    </template>
  </SettingsSelect>
</template>

<style scoped>
</style>
